<div mat-dialog-title class="ed-header">
    <div class="ed-header-main">
        <div class="ed-eyebrow">ECU Build</div>
        <div class="ed-title">Add new ECU Build</div>
    </div>
    <button type="button" class="ed-close" (click)="canceledOption()" aria-label="Close">
        <i class="bi bi-x-lg"></i>
    </button>
</div>

<mat-dialog-content class="ed-content ed-content--stack" [formGroup]="addNewEcuForm" (keydown.enter)="saveNewRow()">
    <div class="ed-grid ed-grid--single">
        <div class="ed-field">
            <label class="ed-field-label">Correct Ecu Build Names <span class="ed-req">*</span></label>
            <input class="ed-field-input" type="text" formControlName="correctEcuBuildNames"/>
            <div class="ed-field-error" *ngIf="addNewEcuForm.controls['correctEcuBuildNames'].hasError('required')">Please enter a correct Ecu Name.</div>
            <div class="ed-field-error" *ngIf="addNewEcuForm?.controls['correctEcuBuildNames']?.hasError('ecuBuildExists')">Ecu Build already exists in database.</div>
        </div>

        <div class="ed-field">
            <label class="ed-field-label">Connected Ecu Build Names</label>
            <input class="ed-field-input" type="text" formControlName="connectedEcuBuildNames"/>
        </div>

        <div class="ed-field">
            <label class="ed-field-label">Accepted Ecu Build Names <span class="ed-req">*</span></label>
            <input class="ed-field-input" type="text" formControlName="acceptedEcuBuildNames"/>
            <div class="ed-field-error" *ngIf="addNewEcuForm.controls['acceptedEcuBuildNames'].hasError('required')">Please enter an accepted Ecu Name.</div>
        </div>

        <div class="ed-field">
            <label class="ed-field-label">Correct Ecu Producer <span class="ed-req">*</span></label>
            <input class="ed-field-input" type="text" formControlName="correctEcuProducer" [matAutocomplete]="ecuProducerAuto"/>
            <mat-autocomplete #ecuProducerAuto="matAutocomplete" class="ed-autocomplete-panel">
                <mat-option *ngFor="let producer of ecuProducerOptions()" [value]="producer">{{ producer }}</mat-option>
            </mat-autocomplete>
            <div class="ed-field-error" *ngIf="addNewEcuForm.controls['correctEcuProducer'].hasError('required')">Please enter a correct Ecu Producer.</div>
        </div>
    </div>
    <div class="ed-field-error" role="alert" *ngIf="saveError">{{ saveError }}</div>
</mat-dialog-content>

<div mat-dialog-actions class="ed-footer">
    <div class="ed-actions" style="margin-left:auto">
        <button type="button" class="ed-btn ed-btn-ghost" (click)="canceledOption()">Cancel</button>
        <button type="button" class="ed-btn ed-btn-primary" [disabled]="addNewEcuForm.invalid || isSaving" (click)="saveNewRow()">
            <i class="bi bi-check-lg"></i>{{ isSaving ? 'Saving...' : 'Save' }}
        </button>
    </div>
</div>
